/**
 * @file ToolsMenu.container.js
 * Exports a redux-connected ToolsMenu component.
 */

import { withRouter } from 'react-router-dom';

import ToolsMenu from './ToolsMenu';

export default withRouter(ToolsMenu);



// WEBPACK FOOTER //
// ./src/components/ToolsMenu/ToolsMenu.container.js